// Cookie helper
import { dmnSetCookie, dmnGetCookie } from "./helpers";

const loaderEl = document.querySelector(".slider-loader");
if (loaderEl) {
    const loaderItems = loaderEl.getElementsByClassName("loader-media-item");
    if (loaderItems?.length && !dmnGetCookie("dtnx-loader") ) {
        const outerWrap = document.getElementById('outer-wrap');

        outerWrap.classList.add("displace");

        let i = 0;

        (function loop() {
            if (i > 0) {
                loaderItems[i - 1].style.display = "none";
            }
            if (++i < loaderItems.length) {
                setTimeout(loop, 700);  // call myself in 3 seconds time if required
            } else {
                outerWrap.classList.remove("displace");
                loaderItems[i - 1].classList.add("shrink");
            }
        })();
        dmnSetCookie('dtnx-loader', true, 365);
    } else{
        loaderEl.style.display = "none";
    }

}